export default __webpack_public_path__ + "static/media/uploadIcon.5605b5e6.svg";